import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';

/**
 * RxJS imports
 */
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-web-modal',
  templateUrl: './web-modal.component.html',
  styleUrls: ['./web-modal.component.scss']
})
export class WebModalComponent implements OnDestroy {

  private subscriptions: Subscription = new Subscription();

  @Input() isShownWebModal;
  @Input() displayObj;
  @Output() resetWebModal = new EventEmitter();

  /**
 * @notifier$ defines a notifier subject stream to end data streaming
 */
 private notifier$ = new Subject();

  /**
   * Necessary instances.
   */
  constructor(
    public fcs: FunCollectionService,
    private dss: DataStorageService) { }

  hideModal(): void {
    this.isShownWebModal = false;
    this.resetWebModal.emit(false);
    this.dss.selected_suggAssList = [];
    this.onHidden();
  }

  onHidden(): void {
    this.isShownWebModal = false;
    this.resetWebModal.emit(false);
    this.dss.selected_suggAssList = [];

    /**
     * Condition used to redirect to home screen from deleted user's info popup.
     */
    if (this.displayObj.errObj.code === 1030) {
      this.fcs.navigateToHome();
    }
  }

    /**
   * unsubscribe the subscription.
   */
    ngOnDestroy(): void {
      this.notifier$.next();
      this.notifier$.complete();
    }

}
